import { useMutation } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useSuggestSubtasks = (projectId, taskId) => {
  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/tasks/${taskId}/subtasks/suggest-subtasks`,
        method: "POST",
        body: data,
      }),
  });
};
